// Quack! This is a duck. https://github.com/erikras/ducks-modular-redux
import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';
import Workspace from './class';

export const actions = {
  REQUEST: 'Dora/workspace/REQUEST',
  RECEIVE: 'Dora/workspace/SUCCESS',
  FAIL: 'Dora/workspace/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'workspace',
  actions,
  requestDataCall: (store, params) => {
    const { hostname } = window.location;
    const subdomain = hostname.split('.')[0];

    const url = `workspaces/${subdomain}${params.full ? '/full' : ''}`;

    return API.get(url, params).then((res) => new Workspace(res));
  },
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/workspace/duck.js